<template>
    <b-card
        no-body
        :border-variant="borderVariant"
        class="supplier-verification-section"
    >
        <div class="card-header pr-2">
            <b-card-title>{{ title }}</b-card-title>
            <b-button
                v-if="addable"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon mt-0 mr-0"
                @click="$emit('add')"
            >
                <feather-icon icon="PlusIcon" />
            </b-button>
        </div>
        <div class="p-2">
            <slot />
            <p
                v-if="empty"
                class="text-muted mb-0"
            >
                {{ emptyText }}
            </p>
        </div>
    </b-card>
</template>

<script>
import { BButton, BCard, BCardTitle } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: { BButton, BCard, BCardTitle },
    directives: { Ripple },
    props: {
        title: {
            type: String,
            required: true,
        },
        addable: {
            type: Boolean,
            default: false,
        },
        empty: {
            type: Boolean,
            default: false,
        },
        emptyText: {
            type: String,
            default: 'There are no documents.',
        },
        theme: {
            type: String,
            default: 'default',
            validator(value) {
                return ['default', 'supplier'].includes(value)
            },
        },
    },
    computed: {
        borderVariant() {
            return this.theme === 'supplier' ? 'primary' : 'light'
        },
    },
}
</script>
